module.exports = __webpack_public_path__ + "img/general-group-seating-map.a276e5a6.jpg";